export const ATR = "ATR";
export const Bicycle = "Bicycle";
export const Classifications = "Classifications";
export const Pedestrians = "Pedestrians";
export const SpotSpeed = "SpotSpeed";
export const TurningMovement = "TurningMovement";
export const GPSSpeed = "GPSSpeed";
